import { Button, SimpleText } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';

const StudentsPrintButton = ({ disabled, onClick, textId, secondary }) => {
    return (
        <Button
            className="students__button_add-parents-access"
            disabled={disabled}
            onClick={onClick}
            view={secondary ? Button.VIEW.SECONDARY : Button.VIEW.ACTION}
        >
            <SimpleText id={textId} />
        </Button>
    );
};

StudentsPrintButton.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    textId: PropTypes.string.isRequired,
    secondary: PropTypes.bool,
};

export default StudentsPrintButton;
